// extracted by mini-css-extract-plugin
export default {"btnWrapper":"Menu_btnWrapper__9N-0S"};